import React from 'react'
import styled from 'styled-components'
import { TileSquareGrid } from 'app/common/tile-square'
import { H2 } from 'app/common/typography'
import { media, ResponsiveContainer } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import type { SuggestionShortDTO } from 'shared/types'
import { eventsDefinitions } from 'shared/store/metadata'
import { pageCategoryMapping } from 'shared/store/metadata'
import { contentFormat } from 'shared/utils'
import { injectIntl } from 'react-intl'
import type { intlShape } from 'react-intl'

type Props = {
    suggestions: SuggestionShortDTO,
    title: string,
    align?: string,
    padding?: string,
    intl: intlShape
}

const FeaturedProducts = injectIntl((props: Props) => {
    const { suggestions, title, align, padding, intl } = props

    /*TODO : WIP Mapping for price */
    const tiles = suggestions.products.map(product => {
        const meta = [
            {
                ...eventsDefinitions['SUGGESTION'],
                event_action: eventsDefinitions[
                    'SUGGESTION'
                ].event_action.concat(title),
                event_label: product.name
            },
            {
                ...eventsDefinitions.GA4_CONTENT_ACCESS,
                ...pageCategoryMapping(intl),
                cta_name: product.name,
                operation_name: product.actionUrl
                    ? product.actionUrl.split('/').pop()
                    : '',
                content_format: contentFormat.SUGGESTION
            }
        ]

        return {
            actionUrl: product.actionUrl,
            image: product.image,
            name: product.name,
            /*DO NOT DELETE => PRICE NODE
            price: product.price ? product.price : null,*/
            backgroundColor: colors.tertiary,
            color: colors.text,
            meta
            /*
            DO NOT DELETE => ICON BOTTOM
            ,iconBottom: (
                <CirclePlus color={'white'} background={colors.red} />
            )*/
        }
    })

    return (
        <Container align={align} padding={padding}>
            {title && (
                <ResponsiveContainer>
                    <H2>{title}</H2>
                </ResponsiveContainer>
            )}
            <StyledResponsiveContainer>
                <TileSquareGrid
                    className="home-tiles"
                    tiles={tiles}
                    margin="8px"
                    hasTileText
                />
            </StyledResponsiveContainer>
        </Container>
    )
})

const StyledResponsiveContainer = styled(ResponsiveContainer)`
    width: calc(100% - 24px);
    margin: 30px auto 60px auto;
    ${media.large`
        margin: 30px auto 60px auto;
    `};
`
const Container = styled.section`
    background: white;
    padding: ${props => (props.padding ? props.padding : '30')}px 0;
    text-align: center;
    ${media.medium`
        padding: ${props => (props.padding ? props.padding : '40')}px 0;
        width: calc(100% - 40px);
        margin: 0 auto;
    `}
    ${media.large`
        width: 1280px;
    `}
    

    ${H2} {
        margin: 5px auto;
        text-align: left;
        ${media.medium`
        text-align: ${props => (props.align ? props.align : 'center')};
        `};
    }
`

export { FeaturedProducts }
